/* eslint-disable react/forbid-prop-types, react/require-default-props */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import { IcChevron, IcCheck } from "./icons";

/**
 * A compact dropdown for the dashboard toolbar: one small button showing the
 * current choice, a quiet menu of options below. Replaces wide segmented
 * controls so the actions row stays uncrowded.
 */
export default function MiniMenu({ icon, label, items, onPick, variant }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("pointerdown", onDown);
    return () => document.removeEventListener("pointerdown", onDown);
  }, [open]);

  return (
    <span className="db-mini" ref={ref}>
      <button
        type="button"
        className={`db-btn sm${variant === "primary" ? " primary" : ""}`}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        {icon}
        {label}
        <IcChevron size={13} className="db-mini-cv" />
      </button>
      {open && (
        <span className="db-mini-menu" role="menu">
          {items.map((it) => (
            <button
              key={it.id}
              type="button"
              role="menuitemradio"
              aria-checked={it.on}
              onClick={() => {
                onPick(it.id);
                setOpen(false);
              }}
            >
              {it.icon}
              <span>{it.label}</span>
              {it.on && <IcCheck size={12} />}
            </button>
          ))}
        </span>
      )}
    </span>
  );
}

MiniMenu.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.node,
  items: PropTypes.array.isRequired,
  onPick: PropTypes.func.isRequired,
  /** "primary" gives the trigger the accent (solid) style — used for Add. */
  variant: PropTypes.string,
};
